import { Slide, SlideTheme } from '@/types/slides'
import { CreatingElement } from '@/types/edit'
import { UserData } from '@/types/user'
import { ToolbarState } from '@/types/toolbar'
import { slides } from '@/mocks/slides'
import { theme } from '@/mocks/theme'
import { SYS_FONTS } from '@/configs/font'
import { TextAttrs, defaultRichTextAttrs } from '@/utils/prosemirror/utils'
import { getCookie } from '@/utils/common'

export interface State {
  inviteInfo: any;
  isVersionShow:boolean;
  isElementCopy: any;
  isFirstSave: boolean;
  slideFonts: any;
  editList:any;
  slidesFontsList:any;
  slidesUseFontsList:any;
  loginModalType:string;
  loginModalState:boolean;
  token: string;
  userInfo: UserData;
  viewportHeight: number;
  viewportWidth: number;
  viewportHeights: number;
  viewportWidths: number;
  viewportType: string;
  tagAllEleState: boolean;
  createDesignModalState: boolean;
  layState: boolean;
  tempState: boolean;
  activeElementIdList: string[];
  hiddenElementIdList: string[];
  handleElementId: string;
  activeGroupElementId: string;
  canvasPercentage: number;
  canvasWidth:number;
  canvasHeight:number;
  canvasScale: number;
  thumbnailsFocus: boolean;
  editorAreaFocus: boolean;
  disableHotkeys: boolean;
  showGridLines: boolean;
  showHotkey:boolean;
  creatingElement: CreatingElement | null;
  availableFonts: typeof SYS_FONTS;
  toolbarState: ToolbarState;
  theme: SlideTheme;
  viewportRatio: number;
  slideTitle: string;
  saveSpinning:boolean;
  slides: Slide[];
  slidesData:any;
  templateData:any;
  isVipVisible:boolean;
  isCopyVisible:boolean;
  downSlideIndex:number;
  slideIndex: number;
  selectedSlidesIndex: number[];
  snapshotCursor: number;
  snapshotLength: number;
  ctrlKeyState: boolean;
  shiftKeyState: boolean;
  spaceKeyState:boolean;
  canvasDragged:boolean;
  screening: boolean;
  clipingImageElementId: string;
  richTextAttrs: TextAttrs;
  selectedTableCells: string[];
  isScaling: boolean;
  scalingCommand:string;
  editingShapeElementId: string;
  editingTextElementId: string;
  editingRectElementId: string;
  layouts: [];
  eleDrawerState: boolean;
  eleThumbState: boolean;
  tempModalState: boolean;
  imagesModalState: boolean;
  eleDrawerType: string;
  seachKey: string;
  seachTotal: number;
  searchHistoryList: [];
  currScence: any;
  currPreviewUrl: '';
  publishTemplateVisible: boolean;
  publishMaterialVisible: boolean;
  currentAllowBack: boolean;
  effectNum: number;
  saveTime: string;
  showVerticalLine: boolean;
  showHorizontalLine: boolean;
  exporting: boolean;
  createID:[],
  openMoreIshow:boolean,
  svgDialogVisible:boolean,
  svgUploadType:string,
  editingClip:boolean,
  mPage:boolean,
  mTemplate:boolean,
  mUser:boolean,
  mImages:boolean,
  mMaterial:boolean,
  mAdd:boolean,
  mBackground:boolean,
  showSelectPanel:boolean
}

export const state: State = {
  isVersionShow:false,
  isElementCopy:false,
  isFirstSave:false,
  editList:[],
  searchHistoryList: [],
  seachKey: '',
  seachTotal: 0,
  loginModalState: false,
  loginModalType: 'wx',
  token: getCookie('userid') || '',
  userInfo: {
    mobile_flag: 'true',
    user_type: 'forever',
    user_type_name: '终身版',
    wechat_flag: 'false',
    openid: null,
    mobile: '13719177525',
    user_nickname: getCookie('user_nickname'),
    sign: '48a3f0b07defa61f12369cb7cc3fe4fd',
    vip_expire_date: '永久',
    avatar: decodeURIComponent(getCookie('avatar')),
    userid: getCookie('userid'),
    update_user_info: true
  },
  viewportHeight: 0,
  viewportWidth: 0,
  viewportHeights: 0,
  viewportWidths: 0,
  viewportType: 'px',
  viewportRatio: 0,
  activeElementIdList: [],
  hiddenElementIdList: [], // 被隐藏的元素ID集合
  handleElementId: '',
  activeGroupElementId: '', // 组合元素成员中，被选中可独立操作的元素ID
  canvasPercentage: 95,
  canvasWidth: 0,
  canvasHeight: 0,
  canvasScale: 1,
  thumbnailsFocus: false,
  editorAreaFocus: false,
  disableHotkeys: false,
  showGridLines: false,
  showHotkey:false,
  creatingElement: null,
  availableFonts: [],
  toolbarState: 'slideDesign',
  theme: theme,
  saveSpinning: false,
  slideTitle: '',
  slides: slides,
  slidesData:{},
  templateData:{},
  isVipVisible:false,
  isCopyVisible:false,
  slideFonts: [],
  slidesFontsList: [],
  slidesUseFontsList:[],
  slideIndex: 0,
  downSlideIndex: 0,
  selectedSlidesIndex: [],
  snapshotCursor: -1,
  snapshotLength: 0,
  ctrlKeyState: false,
  shiftKeyState: false,
  spaceKeyState:false,
  canvasDragged:false,
  screening: false,
  clipingImageElementId: '',
  richTextAttrs: defaultRichTextAttrs,
  selectedTableCells: [],
  isScaling: false,
  scalingCommand: '',
  editingShapeElementId: '',
  editingTextElementId: '',
  editingRectElementId: '',
  editingClip:false,
  layouts: [],
  tempState: true,
  layState: false,
  eleDrawerState: false,
  eleThumbState: true,
  tempModalState: false,
  imagesModalState: false,
  eleDrawerType: '',
  createDesignModalState: false,
  tagAllEleState: false,
  currScence: {},
  currPreviewUrl: '',
  publishTemplateVisible: false,
  publishMaterialVisible: false,
  currentAllowBack: false,
  effectNum: 1,
  saveTime: '',
  showVerticalLine: false,
  showHorizontalLine: false,
  exporting: false,
  createID:[],
  openMoreIshow:false,
  inviteInfo:{},
  svgDialogVisible:false,
  svgUploadType:'',
  mPage:false,
  mTemplate:false,
  mUser:false,
  mAdd:false,
  mImages:false,
  mMaterial:false,
  mBackground:false,
  showSelectPanel:false
}